import PropTypes from "prop-types"
import React from "react"
import { useTranslation } from "react-i18next"
import {
  TextChart,
  TextChartMinor,
} from "components/widgets/ScorePage/widgets/TextCharts"
import HelpWidgetChartInteractiveMolecule from "views/molecules/interactive/HelpWidgetChartInteractiveMolecule"
import Unit from "views/atoms/reports/Unit"
import ChartBadge from "views/atoms/badges/ChartBadge"
import { useAppContext } from "components/AppContext"
import { round } from "services/units/round"
import { convertValueToReadable } from "services/units/valueConversion"
import { CO2_EMISSION_UNITS, T_CO2E } from "services/units/units"
import ChartWithBadgeWrapperMolecule from "views/molecules/charts/ChartWithBadgeWrapperMolecule"

const TextChartODD13GHGEmissionsEmployeeMolecule = ({ score, trendBadge }) => {
  const { t } = useTranslation()
  const { currentRootNode } = useAppContext()

  let ghg_emissions_per_employee =
    Number(score["odd13_CO2_average_employee"]) ?? 0

  // we want to display 1 figure if we are in tons
  let shouldRound = ghg_emissions_per_employee > 1 ? 1 : 0

  const badge = (
    <ChartBadge
      value={ghg_emissions_per_employee * 1000}
      lowerLimit={300}
      upperLimit={600}
      inverse
    />
  )

  let convertedValue = convertValueToReadable(
    ghg_emissions_per_employee,
    T_CO2E,
    CO2_EMISSION_UNITS
  )

  let unit = `score:score.13.${convertedValue.unit}`

  if (ghg_emissions_per_employee < 1) {
    convertedValue.value = ghg_emissions_per_employee * 1000
    unit = `score:score.13.kg_unit`
  }

  const text = currentRootNode?.is_corporate
    ? t("score:score.13.chartGHGEmissionsPerEmployee.corporate.text")
    : t("score:score.13.chartGHGEmissionsPerEmployee.provider.text")

  const help = currentRootNode?.is_corporate
    ? t("score:score.13.chartGHGEmissionsPerEmployee.corporate.help")
    : t("score:score.13.chartGHGEmissionsPerEmployee.provider.help")

  const content = {
    kpi: round(convertedValue.value, shouldRound),
    kpi_unit: <Unit unit={t(unit)} />,
    kpi_text: text,
    reference: badge,
  }

  const content_for_display = <TextChartMinor content={content} />

  const chartContent = (

      <TextChart content={content_for_display} />
  )

  return (
    <HelpWidgetChartInteractiveMolecule text={help}>
      <ChartWithBadgeWrapperMolecule trendBadge={trendBadge} color="auto" >
        {chartContent}
      </ChartWithBadgeWrapperMolecule>
    </HelpWidgetChartInteractiveMolecule>
  )
}

TextChartODD13GHGEmissionsEmployeeMolecule.propTypes = {
  score: PropTypes.object.isRequired,
  trendBadge: PropTypes.object,
}

TextChartODD13GHGEmissionsEmployeeMolecule.defaultProps = {
  trendBadge: null,
}

export default TextChartODD13GHGEmissionsEmployeeMolecule